import useSWR from 'swr';

import { IDetailResponse, IPaginatedResponse, ISimpleListResponse } from 'utils/types';

import { buildQuery, fetcher } from './utils';

export interface IBrand {
  id: number;
  name: string;
}

export const useBrandList = (params?: object) => {
  const url = `/v4/dash/brands`;

  const { data, isLoading, mutate, error, isValidating } = useSWR<IPaginatedResponse<IBrand>>(
    { url, params },
    fetcher
  );

  return { data: data?.data, meta: data?.meta, isLoading, mutate, error, isValidating };
};

export const useBrand = (id?: number | null) => {
  const { data, isLoading, error, mutate, isValidating } = useSWR<IDetailResponse<IBrand>>(
    id ? `/v4/dash/brands/${id}` : null,
    fetcher
  );

  return { data: data?.data, isLoading, error, mutate, isValidating };
};

export const useSimpleBrandList = (params?: object) => {
  const { data, isLoading, mutate } = useSWR<ISimpleListResponse<IBrand>>(
    `/v4/dash/simple/brands?${buildQuery(params)}`,
    fetcher
  );

  return { data: data?.data, isLoading, mutate };
};
